import {
  FieldDataLayerType,
  StacFieldDataLayer,
} from '@xarvio/frontend-core-graphql/schema/schemaTypes.generated';

const fieldDataLayerTypeSet = new Set<string>(
  Object.values(FieldDataLayerType),
);
const stacFieldDataLayerSet = new Set<string>(
  Object.values(StacFieldDataLayer),
);

export const isFieldDataLayerType = (
  value: unknown,
): value is FieldDataLayerType =>
  typeof value === 'string' && fieldDataLayerTypeSet.has(value);

export const isStacFieldDataLayerType = (
  value: unknown,
): value is StacFieldDataLayer =>
  typeof value === 'string' && stacFieldDataLayerSet.has(value);
